import axios from '../axios'

/*
 * 游戏信息
 */

export const selectByPage = (data) => {
    return axios({
        url: '/project/selectByPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/project/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/project/update',
        method: 'post',
        data
    })
}
export const batchDisable = (data) => {
    return axios({
        url: '/project/batchDisable',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/project/batchEnable',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/project/batchDelete',
        method: 'post',
        data
    })
}

export const projectImport = (data) => {
    return axios({
        url: '/project/import',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/pms/game.js